<template>
    <div class="md-house__mask" data-vow="vow_register_mask" :class="[theme]">
        <div class="mask-box">
            <div class="mask-lock">
                <i class="iconfont icon-lock1"></i>
            </div>
            <div
                class="text login"
                v-if="!(notShowLoginArrThemes.includes(theme) && isMobileSize)"
            >
                <p
                    v-html="
                        isLogin
                            ? $t('md-house.emailVerificationRequired')
                            : $t('md-house.freeAccountRequired')
                    "
                ></p>
                <p
                    v-if="!isLogin"
                    v-html="$t('md-house.registerOrSignToView')"
                    v-click="[
                        {
                            selector: '.link.register',
                            callback: register,
                            modifier: { stop: true, prevent: true }
                        },
                        {
                            selector: '.link.sign',
                            callback: signIn,
                            modifier: { stop: true, prevent: true }
                        }
                    ]"
                ></p>
            </div>
        </div>
    </div>
</template>

<script>
import { useUserStore } from '@/store';
import { mapState as rootMapState } from 'pinia';
import signLog from '@/components/sign-log';

const themeArr = [
    'list-v1',
    'list-v2',
    'list-v3',
    'brief-list',
    'brief-house-list',
    'brief-house-list-template4'
]; // The mobile terminal does not display the theme array of login and registration
export default {
    i18next: {
        ns: 'md-house'
    },
    data: function() {
        return {
            notShowLoginArrThemes: themeArr
        };
    },
    props: ['theme', 'address'],
    computed: {
        ...rootMapState(useUserStore, {
            'user': store => store.user
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        isLogin() {
            return !!this.user;
        }
    },
    methods: {
        signIn() {
            signLog.login({
                allowClose: true,
                languageTextFn: {
                    agreementHtml: _ => this.$t('byContinuingYouAgree')
                }
            });
        },
        register() {
            signLog.register({
                allowClose: true,
                languageTextFn: {
                    agreementHtml: _ => this.$t('byContinuingYouAgree')
                },
                onregister: (user, inquiry) => {
                    return false;
                },
                onsuccess: () => {
                    return false; //  Do not pop up the default prompt box
                }
            });
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
.md-house__mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(6px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: var(--level-low);
    background: var(--mask-bg-color);
    .mask-box {
        font-size: 14px;
        text-align: center;
        color: var(--mask-text-color);
        padding: 0 20px;
        .mask-lock {
            width: 30px;
            height: 30px;
            line-height: 30px;
            margin: 0 auto;
            background: var(--g-btn-background);
            border-radius: 50%;
            .icon-lock1 {
                font-size: 14px;
                color: #fff;
            }
        }
        .text {
            margin-top: 15px;
            white-space: nowrap;
            font-family: var(--font-bold);
            color: var(--mask-text-color);
            p {
                margin-bottom: 5px;
                font-size: 14px;
            }
            .link {
                color: var(--color-theme);
                text-decoration: underline;
                font-size: 12px;
                cursor: pointer;
            }
        }
    }
}
</style>
